import { createContext, useContext } from 'react';

export type DataGridMasterDetailColumnsContextValue = {
  /** Master column fields with `visible: false`. */
  hiddenFields: ReadonlySet<string>;
  /** Master column fields currently shown. */
  visibleFields: readonly string[];
};

const defaultValue: DataGridMasterDetailColumnsContextValue = {
  hiddenFields: new Set(),
  visibleFields: [],
};

export const DataGridMasterDetailColumnsContext = createContext<DataGridMasterDetailColumnsContextValue>(defaultValue);

export function useDataGridMasterDetailColumns(): DataGridMasterDetailColumnsContextValue {
  return useContext(DataGridMasterDetailColumnsContext);
}
